module.exports = __webpack_public_path__ + "static/media/requestroll.c719eab3.webp";